import { useState } from 'react';
import { motion } from 'framer-motion';

const instructors = [
  {
    name: 'Szabó-Szőke Renáta',
    role: 'Oktatási vezető, senior tréner',
    image: '/instructor-1.webp',
    bio: '2011 óta dolgozom trénerként és szervezetfejlesztőként multinacionális és KKV környezetben. Fő területeim a vezetői hatékonyság, ügyfélkommunikáció, konfliktuskezelés és stresszkezelés fejlesztése.',
  },
  {
    name: 'Tóth Gabriella',
    role: 'Szakmai tréner',
    image: '/instructor-2.webp',
    bio: '2007 óta dolgozom a Duna House rendszerében értékesítőként és mentorként. Trénerként a gyakorlati értékesítési tapasztalataimat adom át, különös hangsúllyal a kommunikációra és ügyfélkezelésre.',
  },
  {
    name: 'Dr. Káposztás Ágnes',
    role: 'Ügyvéd, külső óraadó',
    image: '/instructor-3.webp',
    bio: '2011 óta dolgozom ügyvédként. Fő szakterületeim az ingatlanjog, cégjog és követeléskezelés. Oktatóként az ingatlanügyletek jogi hátterét közérthető, gyakorlati példákon keresztül mutatom be.',
  },
  {
    name: 'Rádi Gabriella',
    role: 'Tréner',
    image: '/instructor-4.webp',
    imagePosition: 'object-top',
    bio: 'A Duna House oktatási osztályának trénereként új értékesítők szakmai felkészítésével foglalkozom. Képzéseimen a gyakorlati tudásra és a mindennapokban használható értékesítési módszerekre fókuszálok.',
  },
  {
    name: 'Tóth József',
    role: 'Építészmérnök, külső óraadó',
    image: '/instructor-5.webp',
    bio: 'Építészmérnökként és igazságügyi ingatlan-értékbecslő szakértőként több évtizede foglalkozom ingatlanok műszaki és értékbecslési kérdéseivel. Oktatóként a gyakorlati szemléletet képviselem.',
  },
  {
    name: 'Pataki Eszter',
    role: 'Senior tréner, integratív coach',
    image: '/instructor-6.webp',
    bio: 'Trénerként és integratív coachként az önismereti és személyes fejlődési folyamatok támogatásával foglalkozom. A munkámban az egyéni erőforrások tudatosítására és fejlesztésére fókuszálok.',
  },
  {
    name: 'Dr. Veisz Gábor',
    role: 'Ügyvéd, külső óraadó',
    image: '/instructor-7.webp',
    bio: 'Jogi diplomáimat Budapesten és az Egyesült Királyságban szereztem. Ügyvédként dolgozom, emellett nemzetközi szakmai szervezetek munkájában is részt veszek.',
  },
  {
    name: 'Wagner Viktória',
    role: 'Oktatási koordinátor',
    image: '/instructor-8.webp',
    bio: 'Oktatási koordinátorként az oktatási vezető és a trénerek munkáját támogatom, valamint a képzések szervezésében és lebonyolításában veszek részt.',
  },
  {
    name: 'Molnár Viktor',
    role: 'AI tréner',
    image: '/instructor-9.webp',
    imagePosition: 'object-left',
    bio: 'A mesterséges intelligencia gyakorlati alkalmazását tanítom. Képzéseimen a résztvevők megtanulják, hogyan használhatják hatékonyan az AI eszközöket a mindennapi munkájukban — legyen szó szövegírásról, adatelemzésről vagy munkafolyamatok automatizálásáról.',
  },
];

export const Instructors = () => {
  const [openBio, setOpenBio] = useState(null);

  const toggleBio = (idx) => {
    if (window.innerWidth < 1024) {
      setOpenBio(openBio === idx ? null : idx);
    }
  };

  return (
    <section id="oktatok" className="section-padding bg-[#07516B]" data-testid="instructors-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <p className="text-[#FBAF3F] font-mono text-sm tracking-widest uppercase mb-4">
            Oktatóink
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6">
            Szakemberek, akik tudják, miről beszélnek
          </h2>
          <p className="text-white/60 text-lg">
            Minden oktatónk aktív szakember a saját területén. Nem elméleti tudást,
            hanem valós tapasztalatot adnak át — mert ők is nap mint nap használják, amit tanítanak.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
          {instructors.map((instructor, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ delay: idx * 0.1, duration: 0.6 }}
              className="text-center group cursor-pointer"
              data-testid={`instructor-${idx}`}
              onClick={() => toggleBio(idx)}
            >
              <div className="relative mb-4 md:mb-6 mx-auto w-28 md:w-40 overflow-hidden">
                <div className="relative w-28 h-28 md:w-40 md:h-40 overflow-hidden">
                  <img loading="lazy"
                    src={instructor.image}
                    alt={instructor.name}
                    className={`w-full h-full object-cover transition-all duration-500 ${openBio === idx ? 'grayscale-0' : 'grayscale lg:group-hover:grayscale-0'} ${instructor.imagePosition || ''}`}
                  />
                  <div className={`absolute inset-0 border transition-colors duration-300 ${openBio === idx ? 'border-[#56999B]/50' : 'border-white/10 lg:group-hover:border-[#56999B]/50'}`} />
                </div>
                {instructor.bio && (
                  <div className={`overflow-hidden transition-all duration-500 ease-in-out bg-white/10 backdrop-blur-sm ${openBio === idx ? 'max-h-96' : 'max-h-0 lg:group-hover:max-h-96'}`}>
                    <p className="text-white/80 text-xs leading-relaxed p-3">
                      {instructor.bio}
                    </p>
                  </div>
                )}
              </div>
              <h3 className="font-heading text-base md:text-xl font-semibold text-white mb-1">
                {instructor.name}
              </h3>
              <p className="text-[#C4DB72] text-sm">{instructor.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
